import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useEffect, useState } from 'react';
import Tooltip from '@bubble-ui/molecule-tooltip';
import { getArrowDetails, getTooltipTopPosition, getTooltipLeftPosition, getMaxWidth } from './utils';
export default (function (_ref) {
  var _window, _window2;

  var arrow = _ref.arrow,
      children = _ref.children,
      hasFluidWidth = _ref.hasFluidWidth,
      id = _ref.id,
      isLong = _ref.isLong,
      parentRef = _ref.parentRef;
  var parentElement = parentRef.current;

  if (parentElement === null) {
    return null;
  }

  var _useState = useState({
    width: 0,
    height: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      tooltipSize = _useState2[0],
      setTooltipSize = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isVisible = _useState4[0],
      setIsVisible = _useState4[1];

  var rootRef = useRef(null);
  useEffect(function () {
    var _rootRef$current, _rootRef$current2;

    if (tooltipSize.width > 0 && tooltipSize.height > 0 && ((_rootRef$current = rootRef.current) === null || _rootRef$current === void 0 ? void 0 : _rootRef$current.offsetWidth) === tooltipSize.width && ((_rootRef$current2 = rootRef.current) === null || _rootRef$current2 === void 0 ? void 0 : _rootRef$current2.offsetHeight) === tooltipSize.height) {
      setIsVisible(true);
    } else {
      // No need to update state if there is no rootRef.current
      rootRef.current && setTooltipSize({
        width: rootRef.current.offsetWidth || tooltipSize.width,
        height: rootRef.current.offsetHeight || tooltipSize.height
      });
    }
  }, [rootRef.current, tooltipSize.width, tooltipSize.height]);

  var _getArrowDetails = getArrowDetails(arrow),
      arrowDirection = _getArrowDetails.arrowDirection,
      arrowAlign = _getArrowDetails.arrowAlign;

  var parentPosition = parentElement.getBoundingClientRect();
  var scrollY = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollY) || window.pageYOffset;
  var scrollX = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollX) || window.pageXOffset;
  var parentTopPos = scrollY + parentPosition.top;
  var parentLeftPos = scrollX + parentPosition.left;
  var parentWidth = parentElement.offsetWidth || parentPosition.width;
  var parentHeight = parentElement.offsetHeight || parentPosition.height;
  var top = getTooltipTopPosition({
    arrowAlign: arrowAlign,
    arrowDirection: arrowDirection,
    parentHeight: parentHeight,
    tooltipHeight: tooltipSize.height,
    parentTopPos: parentTopPos
  });
  var left = getTooltipLeftPosition({
    arrowAlign: arrowAlign,
    arrowDirection: arrowDirection,
    parentWidth: parentWidth,
    tooltipWidth: tooltipSize.width,
    parentLeftPos: parentLeftPos
  });
  var maxWidth = getMaxWidth({
    arrowAlign: arrowAlign,
    arrowDirection: arrowDirection,
    parentWidth: parentWidth,
    parentLeftPos: parentLeftPos,
    viewportWidth: Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
  });
  var style = {
    position: 'absolute',
    top: top,
    left: left,
    maxWidth: maxWidth,
    opacity: isVisible ? 1 : 0,
    // DialogUnwrapped has zIndex 2147483647,
    // so we need to use the same here in order to have the Tooltip rendered on top of it
    zIndex: isVisible ? 2147483647 : -1
  };
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    ref: rootRef
  }, /*#__PURE__*/React.createElement(Tooltip, {
    arrow: arrow,
    hasFluidWidth: hasFluidWidth,
    id: id,
    isLong: isLong
  }, children));
});
//# sourceMappingURL=PositionedTooltip.js.map